import { render, staticRenderFns } from "./Mybreadcrumb.vue?vue&type=template&id=5b61e1de&scoped=true"
import script from "./Mybreadcrumb.vue?vue&type=script&lang=js"
export * from "./Mybreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./Mybreadcrumb.vue?vue&type=style&index=0&id=5b61e1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61e1de",
  null
  
)

export default component.exports